import React, { Component } from 'react'
import PageManager from './views/components/PageManager/PageManager'
import './App.css'

class App extends Component {
  render () {
    return (
      <PageManager />
    )
  }
}

export default App



// WEBPACK FOOTER //
// ./src/App.js